/*!
 * builder-analytics.js — Tracker CRO custom del builder (regla #61)
 * ~3KB minified · vanilla JS · sin dependencias · NO bloquea render
 *
 * Captura eventos críticos de PDP que Microsoft Clarity / Hotjar
 * NO capturan granular para nuestro tipo de tienda COD LATAM:
 *
 *   - page_view (URL + referrer + viewport + time)
 *   - section_view (qué % de usuarios ve cada section + tiempo en cada una)
 *   - cta_click (data-buy-cta + sticky + mid CTA con posición scroll)
 *   - faq_open (qué pregunta abre el cliente → revela objeción principal)
 *   - scroll_depth (25 / 50 / 75 / 100%)
 *   - time_on_page (segundos totales antes de salir)
 *   - exit_intent (mouse sale del viewport en desktop)
 *
 * Almacenamiento (3 capas):
 *   1. window.builderAnalytics.events (memoria, accesible en DevTools)
 *   2. localStorage 'builder_analytics_session' (persistente en el browser)
 *   3. (Opcional) navigator.sendBeacon al endpoint configurado en
 *      window.BUILDER_ANALYTICS_ENDPOINT (Apps Script Web App)
 *
 * Visualización rápida en DevTools:
 *   > window.builderAnalytics.report()  → table con todos los eventos
 *   > window.builderAnalytics.summary() → resumen agregado
 */
(function () {
  'use strict';
  if (window.builderAnalytics) return; // singleton

  var SESSION_KEY = 'builder_analytics_session';
  var ENDPOINT = window.BUILDER_ANALYTICS_ENDPOINT || null;
  var PRODUCT_HANDLE = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || 'unknown';

  // Session ID compartido entre eventos (regenerado cada 30 min de inactividad)
  function getSessionId() {
    try {
      var data = JSON.parse(localStorage.getItem(SESSION_KEY) || '{}');
      var now = Date.now();
      if (!data.id || (now - (data.lastSeen || 0)) > 30 * 60 * 1000) {
        data = { id: 's_' + now.toString(36) + Math.random().toString(36).slice(2, 8), startedAt: now };
      }
      data.lastSeen = now;
      localStorage.setItem(SESSION_KEY, JSON.stringify(data));
      return data.id;
    } catch (e) {
      return 's_anon_' + Date.now();
    }
  }

  var SESSION_ID = getSessionId();
  var PAGE_LOAD_TIME = Date.now();
  var events = [];
  var scrollMaxDepth = 0;
  var scrollMilestones = { 25: false, 50: false, 75: false, 100: false };
  var sectionTimers = {};
  var sectionVisibleSince = {};

  function track(type, data) {
    var evt = {
      type: type,
      ts: Date.now(),
      tFromLoad: Math.round((Date.now() - PAGE_LOAD_TIME) / 1000),
      session: SESSION_ID,
      product: PRODUCT_HANDLE,
      url: window.location.pathname,
      data: data || {}
    };
    events.push(evt);
    // Limitar a 200 eventos para no inflar memoria/localStorage
    if (events.length > 200) events.splice(0, events.length - 200);

    // Persistir (lazy, throttled)
    if (window.requestIdleCallback) {
      window.requestIdleCallback(persistAndSend, { timeout: 2000 });
    } else {
      setTimeout(persistAndSend, 100);
    }
  }

  var persistThrottle = null;
  function persistAndSend() {
    if (persistThrottle) return;
    persistThrottle = setTimeout(function () {
      persistThrottle = null;
      try {
        var data = JSON.parse(localStorage.getItem(SESSION_KEY) || '{}');
        data.events = events.slice(-50); // últimos 50 en localStorage
        localStorage.setItem(SESSION_KEY, JSON.stringify(data));
      } catch (e) {}
    }, 1000);
  }

  // Send batch on pagehide/visibilitychange (sendBeacon — no bloquea)
  function flushBeacon() {
    if (!ENDPOINT || !navigator.sendBeacon || events.length === 0) return;
    try {
      var payload = JSON.stringify({
        session: SESSION_ID,
        product: PRODUCT_HANDLE,
        ua: navigator.userAgent.slice(0, 200),
        viewport: window.innerWidth + 'x' + window.innerHeight,
        events: events
      });
      navigator.sendBeacon(ENDPOINT, payload);
    } catch (e) {}
  }

  // ─── 1. page_view ───────────────────────────────────────────
  track('page_view', {
    referrer: document.referrer ? document.referrer.slice(0, 200) : 'direct',
    viewport: window.innerWidth + 'x' + window.innerHeight,
    deviceType: window.innerWidth < 768 ? 'mobile' : (window.innerWidth < 1024 ? 'tablet' : 'desktop'),
    title: document.title.slice(0, 100)
  });

  // ─── 2. scroll_depth (throttled rAF) ────────────────────────
  var scrollTicking = false;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      var scrolled = window.scrollY + window.innerHeight;
      var total = document.documentElement.scrollHeight;
      var pct = Math.round((scrolled / total) * 100);
      if (pct > scrollMaxDepth) scrollMaxDepth = Math.min(100, pct);
      [25, 50, 75, 100].forEach(function (m) {
        if (!scrollMilestones[m] && pct >= m) {
          scrollMilestones[m] = true;
          track('scroll_depth', { milestone: m });
        }
      });
      scrollTicking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // ─── 3. cta_click (data-buy-cta + sticky + mid) ─────────────
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-buy-cta], a[href="#form-cod-embed"], a[href="#comprar"], #rsi_buy_now_button, [data-rsi-buy-now]');
    if (cta) {
      var ctaText = (cta.innerText || cta.textContent || '').trim().slice(0, 80);
      // Determinar contexto del CTA (qué sección lo contiene)
      var sectionWrap = cta.closest('[id^="shopify-section-"]');
      var sectionType = 'unknown';
      if (sectionWrap) {
        var match = sectionWrap.id.match(/__([a-z_]+)$/);
        if (match) sectionType = match[1];
      }
      // Sticky CTA vs in-page
      var isSticky = !!cta.closest('[data-stacked-sticky], .stacked-sticky-cta, [data-stacked-mid-desktop], [data-stacked-mid-mobile]');
      track('cta_click', {
        text: ctaText,
        section: sectionType,
        position: isSticky ? 'sticky' : 'in_page',
        scrollPct: Math.round((window.scrollY / document.documentElement.scrollHeight) * 100)
      });
    }
  }, true);

  // ─── 4. faq_open (qué pregunta abre — revela objeción) ──────
  document.addEventListener('click', function (e) {
    var faqBtn = e.target.closest('[data-faq-toggle]');
    if (faqBtn) {
      var question = (faqBtn.querySelector('.faq-q__text') || faqBtn).innerText.trim().slice(0, 120);
      var wasOpen = faqBtn.getAttribute('aria-expanded') === 'true';
      // El toggle aún no se ejecutó — invertir el estado para el log
      if (!wasOpen) {
        track('faq_open', { question: question });
      }
    }
    var showMoreBtn = e.target.closest('[data-faq-show-more]');
    if (showMoreBtn) {
      track('faq_show_more_click', {});
    }
  }, true);

  // ─── 5. disclaimer_open (cliente expande detalles legales) ──
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.dc-summary-*, [class*="dc-summary"]');
    if (summary) {
      track('disclaimer_open', {});
    }
  }, true);

  // ─── 6. section_view (IntersectionObserver per section) ────
  if ('IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.id;
        var match = id.match(/__([a-z_]+)$/);
        var sectionKey = match ? match[1] : id;
        if (entry.isIntersecting) {
          if (!sectionVisibleSince[sectionKey]) {
            sectionVisibleSince[sectionKey] = Date.now();
            track('section_view', { section: sectionKey, scrollPct: Math.round((window.scrollY / document.documentElement.scrollHeight) * 100) });
          }
        } else if (sectionVisibleSince[sectionKey]) {
          var duration = Math.round((Date.now() - sectionVisibleSince[sectionKey]) / 1000);
          if (duration >= 2) {
            // Solo registrar si pasó al menos 2 segundos visible
            sectionTimers[sectionKey] = (sectionTimers[sectionKey] || 0) + duration;
            track('section_time', { section: sectionKey, seconds: duration, totalSeconds: sectionTimers[sectionKey] });
          }
          delete sectionVisibleSince[sectionKey];
        }
      });
    }, { threshold: 0.4 });

    // Esperar a que el DOM esté listo
    function observeSections() {
      var sections = document.querySelectorAll('[id^="shopify-section-"]');
      sections.forEach(function (s) { sectionObserver.observe(s); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeSections);
    } else {
      observeSections();
    }
  }

  // ─── 7. exit_intent (desktop) ───────────────────────────────
  var exitFired = false;
  if (window.innerWidth >= 1024) {
    document.addEventListener('mouseleave', function (e) {
      if (exitFired || e.clientY > 0) return;
      exitFired = true;
      track('exit_intent', {
        scrollPct: Math.round((window.scrollY / document.documentElement.scrollHeight) * 100),
        timeOnPage: Math.round((Date.now() - PAGE_LOAD_TIME) / 1000)
      });
    });
  }

  // ─── 8. time_on_page (al salir/cambiar tab) ────────────────
  function trackTimeOnPage() {
    track('time_on_page', {
      seconds: Math.round((Date.now() - PAGE_LOAD_TIME) / 1000),
      maxScrollDepth: scrollMaxDepth
    });
    flushBeacon();
  }
  window.addEventListener('pagehide', trackTimeOnPage);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') trackTimeOnPage();
  });

  // ─── API pública en window.builderAnalytics ────────────────
  window.builderAnalytics = {
    events: events,
    sessionId: SESSION_ID,
    productHandle: PRODUCT_HANDLE,
    track: track, // permite a otros scripts emitir eventos custom

    report: function () {
      console.group('%c📊 Builder Analytics — Session ' + SESSION_ID, 'font-weight:bold;color:#d4a574;font-size:14px');
      console.table(events.map(function (e) {
        return { type: e.type, tSec: e.tFromLoad, section: e.data.section || '-', detail: JSON.stringify(e.data).slice(0, 80) };
      }));
      console.groupEnd();
      return events;
    },

    summary: function () {
      var counts = {};
      var sectionsViewed = {};
      var ctaClicks = [];
      var faqOpens = [];
      events.forEach(function (e) {
        counts[e.type] = (counts[e.type] || 0) + 1;
        if (e.type === 'section_view') sectionsViewed[e.data.section] = true;
        if (e.type === 'cta_click') ctaClicks.push(e.data);
        if (e.type === 'faq_open') faqOpens.push(e.data.question);
      });
      var summary = {
        sessionId: SESSION_ID,
        product: PRODUCT_HANDLE,
        totalEvents: events.length,
        eventTypes: counts,
        sectionsViewed: Object.keys(sectionsViewed),
        sectionTimers: sectionTimers,
        scrollMaxDepth: scrollMaxDepth + '%',
        ctaClicks: ctaClicks,
        faqOpens: faqOpens,
        timeOnPage: Math.round((Date.now() - PAGE_LOAD_TIME) / 1000) + 's'
      };
      console.log('%c📊 Builder Analytics Summary', 'font-weight:bold;color:#d4a574;font-size:14px', summary);
      return summary;
    },

    clear: function () {
      events.length = 0;
      try { localStorage.removeItem(SESSION_KEY); } catch (e) {}
      console.log('Builder Analytics: session cleared');
    }
  };

  // Console hint (solo si DevTools abierto — no afecta usuario normal)
  if (window.console && console.log) {
    console.log('%c📊 Builder Analytics activo', 'background:#d4a574;color:#000;padding:2px 8px;border-radius:3px;font-weight:bold', '→ window.builderAnalytics.report() para ver eventos');
  }
})();
